export default __webpack_public_path__ + "static/media/AB.6e170ad0.png";